import "../css/style.css";
import Alpine from "alpinejs";

window.Alpine = Alpine;

window.scrollHandler = (sectionClass, options = {}) => ({
  activeSection: "",
  sections: [],
  locked: false,
  timer: null,
  menuOpened: false,
  menuVisible: false,
  navbarHeight: 0,
  options: {
    offset: 200,
    lockDuration: 1010,
    smoothScrollDuration: 1000,
    ...options,
  },

  init() {
    this.sections = document.getElementsByClassName(sectionClass);
    // this.navbarHeight =
    //   parseInt(
    //     getComputedStyle(document.documentElement).getPropertyValue(
    //       "--navbar-height",
    //     ),
    //   ) || 0;
    this.handleHashNavigation();
  },

  changeActiveSection(sectionId) {
    this.setActiveSection(sectionId);
    this.lockUpdates();

    this.timer = setTimeout(() => {
      this.menuVisible = true;
    }, 400);
  },

  calculateHeight(position) {
    if (this.locked) return;

    const isScrollingDown = position > (this.lastScrollPosition || 0);
    this.lastScrollPosition = position;

    // Use different offsets based on scroll direction
    const offset = isScrollingDown
      ? this.options.offset
      : this.options.offset * 2;

    if (isScrollingDown) {
      // Scrolling down - original logic
      for (const section of this.sections) {
        const sectionName = section.id;
        const distanceFromTop = section.offsetTop;
        const start = distanceFromTop - position - this.navbarHeight;

        if (start < this.options.offset && start > 0) {
          this.setActiveSection(sectionName);
          break;
        }
      }
    } else {
      // Scrolling up - iterate in reverse and react earlier
      for (let i = this.sections.length - 1; i >= 0; i--) {
        const section = this.sections[i];
        const distanceFromTop = section.offsetTop;
        const start = distanceFromTop - position - this.navbarHeight;

        if (start <= offset) {
          this.setActiveSection(section.id);
          break;
        }
      }
    }

    this.menuVisible = position > this.sections[0]?.offsetTop - 50;

    if (position + window.innerHeight >= document.body.scrollHeight) {
      this.setActiveSection(this.sections[this.sections.length - 1]?.id || "");
    } else if (
      position <
      (this.sections[0]?.offsetTop || 0) - this.options.offset
    ) {
      this.setActiveSection(this.sections[0]?.id || "");
    }
  },

  handleHashNavigation() {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      this.scrollToSection(hash);
      this.menuVisible = true;
    } else {
      this.setActiveSection(this.sections[0]?.id || "");
    }
  },

  scrollToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
      this.setActiveSection(sectionId);
      this.lockUpdates();
      section.scrollIntoView({ behavior: "smooth" });
    }
  },

  setActiveSection(sectionId) {
    this.activeSection = sectionId;
  },

  lockUpdates() {
    this.locked = true;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.locked = false;
    }, this.options.lockDuration);
  },
});

Alpine.start();
